export default {
  WECHAT_FRIENDS: '微信好友',
  GENERATE_IMAGES: '生成图片',
  SAVE_PICTURE: '保存图片',
  CANCEL_ACTION: '取消',
  AMAZON_OVERSEAS_PURCHASING_USERS: '亚马逊海外购用户',
  RECOMMEND_EXCELLENT_PRODUCTS_TO_YOU: `· 向你推荐超棒好货 ·`,
  WECHAT_SHARE_TITLE: '·海外直邮 正品保证\n·官方客服 满300免邮',
  WECHAT_IS_NOT_INSTALLED: '尚未安装微信',
  GENERATE_IMAGES_SUCCEED: '生成图片成功',
  SHARE_WECHAT_SUCCEED: '分享成功',
  SELECT_IMAGES_TO_GENERATE_POST_THRESHOLD: '最多可选6张展示图生成海报'
};
